import styled from 'styled-components';
import { MenuItem } from '@material-ui/core';

export const StyledMenuItem = styled(MenuItem)`
  font-size: 0.875rem!important;
  padding-left: 14px!important;
  padding-right: 14px!important;
`;